// =====================================================================================================================
// LOGO VIEW
//
//  The logo for the website. You touch it and it takes you back to the home.
//

import { GridContainer, Ui, VertContainer } from "@stratisopt/platform";
import { UiFactory } from "@stratisopt/platform";

export class LogoView extends VertContainer {

    // =================================================================================================================
    // CONSTRUCTORS
    //

    // Create and initialize a new instance
    public static create(json:any):LogoView {
        let ui = new LogoView();
        ui.init(json);
        return ui;
    }

    // Initialize this instance
    public init(json:any) {

        // Initialize the super
        super.init(this._json);
        UiFactory.addChildren(this, this._json);

        // Update with json overrides (if they exist)
        if (json !== undefined) {
            this.setFieldsFromJson(json);           
        }
    }


    // =================================================================================================================
    // VIEW
    //

    private _json = {
        alignContentX:'mid', children:[
        {type:'image', sizeX:'100px', sizeY:'100px', cursor:'pointer', onTouch:'App.Show homeView', value:'/assets/image/Logo.png'},
        {type:'H_CONTAINER', pad:Ui.theme.SPACING_Neutral, children:[
            {type:'text', textSize:Ui.theme.SIZE_FontEmphasize, textShadow:Ui.theme.COLOR_FontShadow, textColor:Ui.theme.COLOR_LogoOrange, padR:'6px', value:'Toph'},
            {type:'text', textSize:Ui.theme.SIZE_FontEmphasize, textShadow:Ui.theme.COLOR_FontShadow, textColor:Ui.theme.COLOR_LogoGreen, value:'Balli'},
            {type:'text', textSize:Ui.theme.SIZE_FontEmphasize, textShadow:Ui.theme.COLOR_FontShadow, textColor:Ui.theme.COLOR_LogoPurple, value:'nger'},
        ]}
    ]}
            


}
